module.exports = __webpack_public_path__ + "static/media/27.a4e35042.jpg";